export const backendApi = 'https://raksha-backend.onrender.com'





